import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link, withRouter } from 'react-router';
import ShowOptionGroups from '../components/optiongroups/ShowOptionGroups';
import { clearAuthErrors, fetchOptionGroups, disableOptionGroup, clearOptionGroupsErrors } from '../actions';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import RaisedButton from 'material-ui/RaisedButton';
import Pagination from '../components/home/Pagination';
import TextField from 'material-ui/TextField';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  optiongroups: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};

class OptionGroupPage extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  // TODO: review this, why duplication on each Container - gabo
  getChildContext() {
    return {
      muiTheme: getMuiTheme(baseTheme),
    };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
    this.props.dispatch(clearOptionGroupsErrors());
    const query = this.props.query;
    const router = this.props.router;
    if (this.props.optiongroups.search && this.props.optiongroups.search.length > 0) {
      query.search = this.props.optiongroups.search;
    }
    if (!query.page) {
      query.page = 1;
      router.push({ pathname: '/optiongroups', query });
    } else {
      this.props.dispatch(fetchOptionGroups(query));
    }
  }
  onOptionGroupDisable(data) {
    this.props.dispatch(disableOptionGroup(data));
  }
  handleSearchChange(e) {
    const optiongroups = this.props.optiongroups;
    const query = this.props.query;
    const router = this.props.router;
    const nextOptionGroup = e.target.value;
    optiongroups.search = nextOptionGroup;
    this.setState({
      optiongroups,
    });
    if (nextOptionGroup.length > 0) {
      query.search = nextOptionGroup;
    } else {
      delete query.search;
    }
    query.page = 1;
    router.push({ pathname: '/optiongroups', query });
    this.props.dispatch(fetchOptionGroups(query));
  }
  navigation(route) {
    // add search to url
    this.props.dispatch(fetchOptionGroups(route));
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    };
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="optiongroup component" style={authPage}>
        <h2>Option Groups</h2>
        <div className="content">
          <div className="action-buttons">
            <Link to="/optiongroups/new">
              <RaisedButton
                label="Add New Option Group"
                primary
              />
            </Link>
          </div>
          <div className="action-buttons top">
            <TextField
              floatingLabelText="Search by Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              inputStyle={styles.inputStyle}
              value={this.props.optiongroups.search}
              onChange={this.handleSearchChange}
            />
            <Pagination
              paginationInfo={this.props.optiongroups.meta}
              pageCall={route => this.navigation(route)}
            />
          </div>
          <hr />
          <ShowOptionGroups
            optiongroups={this.props.optiongroups}
            onOptionGroupDisable={data => this.onOptionGroupDisable(data)}
          />
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.optiongroups.meta}
            pageCall={route => this.navigation(route)}
          />
        </div>
      </div>
    );
  }
}

OptionGroupPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

OptionGroupPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    optiongroups: state.optiongroups,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(OptionGroupPage));



// WEBPACK FOOTER //
// ./src/containers/OptionGroupsPage.js